
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import * as ChartModuleMore from 'highcharts/highcharts-more.js';
import HCSoldGauge from 'highcharts/modules/solid-gauge';
import Highcharts from 'highcharts'
ChartModuleMore(Highcharts);
HCSoldGauge(Highcharts);

class Chart extends Component {
	constructor() {
		super();
		this.state = {
			data: null
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS2, { quarter: this.props.cerrent_quarter }, ({ datas }) => {
			this.setState({
				data: datas
			}, () => {
				Alert.LoadingClose()
				this.setChart(datas)
			})
		})

	}
	setChart = (list) => {
		var categories = []
		var val_set = []
		list.map((row) => {
			categories.push(row.name + " ( N:" + row.count + ")")
			val_set.push(parseFloat(row.avg))
			// series.push({
			// 	name: row.name,
			// 	data: [parseFloat(row.avg)]
			// })
		})
		var series = [
			{
				name: 'Quarter : ' + this.props.cerrent_quarter + "/" + (this.props.cerrent_quarter == 2 || this.props.cerrent_quarter == 3 ? "21" : "22"),
				data: val_set,
				events: {
					click: (e) => {
						this.handleClickChart(e, categories.indexOf(e.point.category))
					}
				}
			}
		]
		Highcharts.chart('chart_2_1_l2', {

			title: {
				text: 'Quarter : ' + this.props.cerrent_quarter + "/" + (this.props.cerrent_quarter == 2 || this.props.cerrent_quarter == 3 ? "21" : "22")
			},

			subtitle: {
				text: ''
			},

			yAxis: {
				title: {
					text: ''
				}
			},

			xAxis: {
				// accessibility: {
				// 	rangeDescription: 'Range: 2010 to 2017'
				// },
				categories: categories
			},

			// // legend: {
			// // 	layout: 'vertical',
			// // 	align: 'right',
			// // 	verticalAlign: 'middle'
			// },

			plotOptions: {
				series: {
					label: {
						connectorAllowed: false
					},
					// pointStart: 2010,
					// point: {
					// 	events: {
					// 		click: (e) => this.handleClickChart(e, {}, {})
					// 	}
					// }
				}
			},
			series: series,

			responsive: {
				rules: [{
					condition: {
						maxWidth: 500
					},
					chartOptions: {
						legend: {
							layout: 'horizontal',
							align: 'center',
							verticalAlign: 'bottom'
						}
					}
				}]
			}
		});
	}
	handleClickChart = (e, index) => {
		this.props.callbackChangelevel({ level: 3, data: this.state.data[index] })
	}
	render() {
		return (
			<div className={"chart-box"}>
				<center>
					<div id="chart_2_1_l2" style={{ width: "94%", height: "450px" }}></div>
				</center>
			</div>
		);
	}
}

export default Chart;